

import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About MOJ</h1>
          <p>Reimagining inter-city travel in Pakistan</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>MOJ was founded with a simple mission: to make inter-city travel in Pakistan safe, reliable, and comfortable. What started as a small service connecting Islamabad and Rawalpindi has grown into a trusted transportation network serving major cities across the country.</p>
              <p>We partner with Pakistan's leading corporations to provide seamless staff transportation solutions, while also offering individual riders a premium travel experience at affordable prices.</p>
            </div>
            <div className="about-stats">
              <div className="stat-card">
                <h3>4</h3>
                <p>Cities Connected</p>
              </div>
              <div className="stat-card">
                <h3>10K+</h3>
                <p>Monthly Rides</p>
              </div>
              <div className="stat-card">
                <h3>4</h3>
                <p>Corporate Partners</p>
              </div>
              <div className="stat-card">
                <h3>99%</h3>
                <p>Safety Rating</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="container">
          <h2 className="section-title">Our Mission</h2>
          <div className="mission-cards">
            <div className="mission-card">
              <h3>🎯 Reliability</h3>
              <p>On-time pickups, every time. We value your schedule.</p>
            </div>
            <div className="mission-card">
              <h3>🛡️ Safety</h3>
              <p>Verified drivers, tracked rides, and 24/7 support.</p>
            </div>
            <div className="mission-card">
              <h3>💡 Innovation</h3>
              <p>Technology-driven solutions for modern Pakistan.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;